<div class="emds"
     [ngClass]="{'required': isRequired(), 'required-invalid': form?.submitted && fileUploadControlFormControl?.invalid}">
  <mat-form-field appearance="outline" class="emds-find-control">
    <mat-chip-list #chipList [disabled]="disableChips" matPrefix>
        <mat-chip *ngFor="let chip of chips"
                  [removable]="true"
                  (removed)="removeFile(chip)">
          <div class="chip-name-container">
            {{chip.name}}
          </div>
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
    </mat-chip-list>
    <input
        #chipInput
        [matChipInputFor]="chipList"
        type="text"
        id="{{Id}}-text-input"
        disabled
        class="emds-find-control-text-input">
    <input class="file-input" #uploadInput type="file" multiple onclick="value=null" (change)="selectFiles($event)" />
    <mat-icon matSuffix class="emds-find-control-icon clickable" (click)="inputUpload()">search</mat-icon>
  </mat-form-field>
  <div class="incorrect-input"
       *ngIf="isRequired() && form?.submitted && fileUploadControlFormControl?.invalid">
       {{(fileUploadControlDisplayName || 'File Upload') + ' is a required field' | translate}}
  </div>
</div>
